import React from "react";
import { Link } from "react-router-dom";
import "../css/policyPages.scss";

const questions = [
  {
    question: "How do I place an order?",
    answer: (
      <>
        Add your chosen item and options to the shopping bag, then review the
        summary. Online payment is not connected yet, so contact{" "}
        <a href="mailto:boxes@jskerandco.club">boxes@jskerandco.club</a> to
        confirm availability, delivery, and the approved payment method.
      </>
    ),
  },
  {
    question: "Does the website collect card details?",
    answer:
      "No. The website does not ask for or store card numbers, expiration dates, or security codes. Never send full card details through email or the contact form.",
  },
  {
    question: "Which product options are available?",
    answer:
      "Available sizes, finishes, colors, stones, and other choices are listed on each product page. Options vary by design and should be reviewed before you request an order.",
  },
  {
    question: "How should I choose a ring size?",
    answer:
      "Use a recent measurement from a professional jeweler when possible. Fit can vary with band width and design, so contact us before ordering if you are between sizes.",
  },
  {
    question: "Will colors look exactly like they do on screen?",
    answer:
      "Images show the design and available color direction. Screen settings, lighting, stone variation, and material finish may cause the delivered appearance to differ slightly.",
  },
  {
    question: "When will my order arrive?",
    answer: (
      <>
        Preparation and delivery estimates depend on the item, destination, and
        available service. The estimate confirmed for your order is the one that
        applies. See <Link to="/shipping">Shipping Information</Link> for more.
      </>
    ),
  },
  {
    question: "Can I change or cancel a personalized item?",
    answer:
      "Contact us as soon as possible. Work may begin shortly after an order is accepted, so changes or cancellation may not be possible once production has started.",
  },
  {
    question: "Can personalized jewelry be returned?",
    answer: (
      <>
        Eligibility depends on the item, condition, selected options, and
        applicable consumer law. Do not send anything back before receiving
        instructions. Review <Link to="/returns">Returns & Order Help</Link>.
      </>
    ),
  },
  {
    question: "How do I care for my jewelry?",
    answer:
      "Keep pieces dry and separate when stored. Avoid perfume, household chemicals, swimming, and abrasive cleaners. Use a soft lint-free cloth and follow any material-specific care supplied with the item.",
  },
  {
    question: "How can I contact Jskerandco?",
    answer: (
      <>
        Email <a href="mailto:boxes@jskerandco.club">boxes@jskerandco.club</a>.
        Include the product name and, for an existing order, your order
        reference. Do not include complete payment-card details.
      </>
    ),
  },
];

function FAQs() {
  return (
    <main className="policy-page faq-page">
      <header className="policy-hero">
        <nav aria-label="Breadcrumb">
          <Link to="/">Home</Link>
          <span aria-hidden="true">/</span>
          <span>FAQs</span>
        </nav>
        <p className="policy-kicker">Order help</p>
        <h1>Frequently Asked Questions</h1>
        <p className="policy-intro">
          Clear answers about products, sizing, orders, delivery, returns, and
          payment safety.
        </p>
      </header>

      <div className="faq-layout">
        <section className="faq-list" aria-label="Frequently asked questions">
          {questions.map(({ question, answer }, index) => (
            <details key={question} open={index === 0}>
              <summary>
                <span>{question}</span>
                <span className="faq-marker" aria-hidden="true">+</span>
              </summary>
              <div className="faq-answer"><p>{answer}</p></div>
            </details>
          ))}
        </section>

        <aside className="faq-contact">
          <p className="policy-kicker">Still need help?</p>
          <h2>Talk to us before ordering</h2>
          <p>
            Send the product name and your question. We will help clarify the
            available options and next steps.
          </p>
          <a href="mailto:boxes@jskerandco.club">Email customer care</a>
        </aside>
      </div>
    </main>
  );
}

export default FAQs;
